const CONF_LAN={
    'cn':{
        'img_real_dir':(BASE_MOBILE_ROOT+'img/cn/'),
        'img_dir':(BASE_MOBILE_ROOT+'img/cn/'),
        'contact':{
            'mail':{
                'icon':BASE_MOBILE_ROOT+'img/cn/'+'contact_main_mail.png',
                'title':SITE_MAILS['index'],
            },
            'shanghaiphone':{
                'icon':BASE_MOBILE_ROOT+'img/cn/'+'contact_main_phone.png',
                'title':'+86 (0) 21<font style="visibility: hidden">5</font> 54569595 (上海)',
            },
            'shenzhenphone':{
                'icon':BASE_MOBILE_ROOT+'img/cn/'+'contact_main_phone.png',
                'title':'+86 (0) 755 86013388 (深圳)',
            },
        },
        'contact_subs':[
            {
                'type':'DIALOG_IMG',
                'img':BASE_MOBILE_ROOT+'img/common/'+'qrcode_new.jpg',
                'title':'微信',
                'name':'wechat',
                'id':'wechat',
                'seq':1,
                'sprit_index':1
            },
            {
                'type':'URL',
                'url':'http://weibo.com/nextstudio',
                'title':'微博',
                'name':'weibo',
                'id':'weibo',
                'seq':2,
                'sprit_index':2
            },
            {
                'type':'URL',
                'url':'https://www.linkedin.com/company/nextstudios/',
                'title':'LinkedIn',
                'name':'LinkedIn',
                'id':'LinkedIn',
                'seq':7,
                'sprit_index':7
            },
            {
                'type':'URL',
                'url':'https://discordapp.com/invite/XjFHYZG',
                'title':'Discord',
                'name':'Discord',
                'id':'Discord',
                'seq':8,
                'sprit_index':8
            },

        ]
    },
    'en':{
        'img_real_dir':(BASE_MOBILE_ROOT+'img/en/'),
        'img_dir':(BASE_MOBILE_ROOT+'img/cn/'),
        'contact':{
            'mail':{
                'icon':BASE_MOBILE_ROOT+'img/cn/'+'contact_main_mail.png',
                'title':SITE_MAILS['index'],
            },
            'shanghaiphone':{
                'icon':BASE_MOBILE_ROOT+'img/cn/'+'contact_main_phone.png',
                'title':'+86 (0) 21<font style="visibility: hidden">5</font> 54569595 (Shanghai)',
            },
            'shenzhenphone':{
                'icon':BASE_MOBILE_ROOT+'img/cn/'+'contact_main_phone.png',
                'title':'+86 (0) 755 86013388 (Shenzhen)',
            },
        },
        'contact_subs':[
            {
                'type':'URL',
                'url':'https://twitter.com/NEXTStudios',
                'title':'Twitter',
                'name':'Twitter',
                'id':'Twitter',
                'seq':3,
                'sprit_index':3
            },
            {
                'type':'URL',
                'url':'https://www.facebook.com/NEXTStudios/',
                'title':'Facebook',
                'name':'Facebook',
                'id':'Facebook',
                'seq':4,
                'sprit_index':4
            },
            {
                'type':'URL',
                'url':'https://www.instagram.com/nextstudios/',
                'title':'Instagram',
                'name':'Instagram',
                'id':'Instagram',
                'seq':5,
                'sprit_index':5
            },
            {
                'type':'URL',
                'url':'https://www.youtube.com/channel/UCKE_CfoSegV4sJZxLhHgYWg/featured?view_as=subscriber',
                'title':'YouTube',
                'name':'YouTube',
                'id':'YouTube',
                'seq':6,
                'sprit_index':6
            },
            {
                'type':'URL',
                'url':'https://www.linkedin.com/company/nextstudios/',
                'title':'LinkedIn',
                'name':'LinkedIn',
                'id':'LinkedIn',
                'seq':7,
                'sprit_index':7
            },
            {
                'type':'URL',
                'url':'https://discordapp.com/invite/XjFHYZG',
                'title':'Discord',
                'name':'Discord',
                'id':'Discord',
                'seq':8,
                'sprit_index':8
            },

        ]
    },
}
export default CONF_LAN;